import React,{useState,useEffect} from 'react'
import Parosidebar from '../Components/Parosidebar';
import Paronavbar from '../Components/Paronavbar';
import ParoAdduserMain from '../Components/ParoAdduserMain';
import { Link } from 'react-router-dom';
import logout from '../Assets/Images/logout.png'

const ParoAdduser = () => {
  const [sidebar, setSidebarOpen]=useState(false);
  const togglesidebar = ()=> {
      setSidebarOpen((prevState) => !prevState);
    }

    
    useEffect(()=>{const venture = localStorage.getItem('ventureid');
    if(venture!=='02'){document.getElementById("Paro-dashboard").style.display="none"}
    else{ document.getElementById("Paro-dashboard").style.display="grid"}
   },[]);


   
      /*---Once logout then clear localstorage function----*/

    function removelocalstorage(){
        localStorage.clear()
        window.location.href='/'

      }


      /*----Logout form function----*/

    function ToggleLogform()
     {
        document.getElementById("modalLogoutForm").style.display = "block";
     }
     
     
      
     function closeForm()
     {
        document.getElementById("modalLogoutForm").style.display = "none";
      
      }
     


  return (
    <div className='parop-container' id="Paro-dashboard">
      <Paronavbar sidebar={sidebar} openSidebar={togglesidebar}/>
      <Parosidebar sidebar={sidebar} openLogForm={ToggleLogform} />
      <ParoAdduserMain/>

      <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="Parologcenterform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
            <h5 id="Parodellog" ><img src={logout} id="causeimg"></img><br></br>Are you sure want to Logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="Paro-delete-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="Paro-delete-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>
    </div>
  )
}

export default ParoAdduser